import React from 'react';
import { useTranslation } from 'react-i18next';
import Block from '../../Block';
import PieChart from '../../charts/PieChart'
import { Loader } from '../../components';
import { useGetDashboardLocationStatusQuery } from '../../../api/dashboardApiSlice';

const LocationStatus = ({filter, ...props}) => {
  const { t } = useTranslation();
  const {data = [], isSuccess, isLoading, isError, refetch} = useGetDashboardLocationStatusQuery({filter})
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const pieData = data.map((x)=>(
    {"name":x.location_status,"y":x.active_devices}
  ))

  return (
    <Block title={t("publisher.location_status")} {...props}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <PieChart data={pieData} legendOptions={{show: false}} datalabels/>
      </Loader>
    </Block>
  )
}

export default LocationStatus
